<template>

</template>

<script>

  import store from '../../store'
  import ajax from 'services/ajax'

  export default {
    name: 'novnc',
    data () {
      return {
      }
    },
    created () {
      var hostingId = this.$route.params.id
      store.commit('setLoading', true)
      ajax.run(this, 'customer/vms/' + hostingId + '/novnc', (data) => {
        store.commit('setLoading', false)
        window.location.replace('https://' + data.vm.server.host + ':8006/novnc/mgnovnc.html?vncticket=' + data.vnc.ticket + '&token=' + data.auth.ticket + '&port=' + data.vnc.port + '&node=' + data.vm.server.node + '&vmid=' + data.vm.proxmox_vm_id + '&virtualization=qemu&UserName=' + data.vnc.user + '&CSRFPreventionToken=' + data.auth.CSRFPreventionToken)
      }, (error) => {
        store.commit('setLoading', false)
        console.log(error)
      })
    },
    methods: {
    },
  }
</script>

<style lang="scss">
  @import "../../sass/_variables.scss";

  .btn-custom {
    min-width: 305px;
  }

  .position-box {
    margin-right: 2px;
    cursor: pointer;
    background-color: $brand-primary;
    opacity: 0.6;

    &:last-child {
      margin-right: 0;
    }

    &:hover {
      opacity: 0.9;
    }

    &.selected {
      opacity: 1;
      border-style: solid;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/management/Novnc.vue